document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.getElementById('mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
      menu.hidden = open;
    });
  }
  const selector = document.querySelector('[data-variant-select]');
  if (selector) {
    const price = document.querySelector('[data-price]');
    const compare = document.querySelector('[data-compare-price]');
    const add = document.querySelector('[data-add-button]');
    selector.addEventListener('change', () => {
      const option = selector.selectedOptions[0];
      if (!option) return;
      price.textContent = option.dataset.price;
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      add.disabled = option.dataset.available !== 'true';
      add.innerHTML = option.dataset.available === 'true' ? 'ADD TO BAG <span aria-hidden="true">↗</span>' : 'SOLD OUT';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  }
});
